import { Company } from '@src/@data/types/company';
import { Cache } from '@src/@data/utility/cache/Cache';
import companyApi from '@data/api/company';

export class CompaniesCache extends Cache<Company[]> {
  fetchData(): Promise<Company[]> {
    return companyApi.listMyCompanies();
  }
}
